<template>
    <div v-if="!isLoading" class="family-search-header-title pa-h-6 pa-overflow-hidden pa-text-[16px] pa-font-semibold pa-leading-6">
        <ElPopover
            popperClass="family-search-header-title__popover"
            placement="top-start"
            trigger="hover"
            :visibleArrow="false"
            :openDelay="POPPER_OPEN_DELAY"
        >
            <template #reference>
                <p class="pa-overflow-hidden pa-overflow-ellipsis pa-whitespace-nowrap" v-html="title" />
            </template>
            <p class="pa-max-w-[400px] pa-break-words pa-text-black" v-html="title" />
        </ElPopover>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Popover } from 'element-ui';
import { POPPER_OPEN_DELAY } from '@/constants';
import { useFamilySearchPatentInfo } from '@/composables/use-family-search-patent-info';
import { useI18n } from '@/composables/use-i18n';

const ElPopover = Popover;
const { patentInfo, isLoading } = useFamilySearchPatentInfo();
const { t } = useI18n();

const title = computed(() => `${patentInfo.value.translation ? `[${t('translateTitle')}]` : ''} ${patentInfo.value.title || ''}`);
</script>

<style lang="scss">

</style>
